module.exports = __webpack_public_path__ + "media/1.43ad8478.mp3";